var React = require('react');

function SVGWaveBG (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1440 0H0C0 0 0.003703 413.412 4.8697e-05 603C4.2253e-05 603.334 68.5 691 350.5 626C632.5 561 821.5 626.5 1027.5 651.5C1233.5 676.5 1440 575.5 1440 575.5V0Z","fill":"var(--lightSectionBg)"}));
}

SVGWaveBG.defaultProps = {"preserveAspectRatio":"none","viewBox":"0 0 1440 656","fill":"none"};

module.exports = SVGWaveBG;

SVGWaveBG.default = SVGWaveBG;
